module.exports = __webpack_public_path__ + "static/media/icon_blackboard_white.63d5c669.svg";